// eslint-disable-next-line import/no-extraneous-dependencies
import * as RadixDropdown from "@radix-ui/react-dropdown-menu";
import { styled } from "@vitality-ds/system";
import contentStyles from "../../styles/Content.styles";
import baseDropdownMenuItemStyles from "../DropdownMenuItem/styles/BaseItem.styles";
import baseSubmenuTriggerStyles from "./styles/BaseSubmenuTrigger.styles";
export var BaseSubContent = styled(RadixDropdown.SubContent, contentStyles);
export var BaseSubTrigger = styled(RadixDropdown.SubTrigger, baseDropdownMenuItemStyles, baseSubmenuTriggerStyles);
var BaseSubmenu = RadixDropdown.Sub;
export { BaseSubmenu };